const processSubjectsMulti = (data) => {
  let arr = [];
  Object.keys(data).map((key, index) => {
    if (data[key].qualification.id <= 3) {
      //1,2,3 = A-Level,IB,IGCSE >>>> Display Qualification + Subject
      arr[index] = {
        value: data[key].id,
        label: data[key].qualification.name + " " + data[key].name,
      };
    } else {
      arr[index] = { value: data[key].id, label: data[key].name };
    }
    return arr;
  });
  return arr;
};

export default function api_subject(
  state = {
    subjects: null,
    subjects_multi_select: null,
    qualifications: null,
  },
  action
) {
  switch (action.type) {
    case "FETCH_SUBJECTS_SUCCESS":
      const processedSubjects = processSubjectsMulti(action.response.data);
      return {
        ...state,
        isLoading: false,
        subjects: action.response.data,
        subjects_multi_select: processedSubjects,
      };

    case "FETCH_QUALIFICATIONS_SUCCESS":
      return {
        ...state,
        isLoading: false,
        qualifications: action.response.data,
      };

    default:
      return state;
  }
}
